import {serializable, alias, object, list, primitive} from 'serializr';

export class Leaderboard { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('email', primitive()))
	email?: string;

	@serializable(alias('phoneNumber', primitive()))
	phoneNumber?: string;

	@serializable(alias('rank', primitive()))
	rank?: number;

	@serializable(alias('id', primitive()))
	studentId?: number;

	@serializable(alias('points', primitive()))
	cummulativeScore?: number;

	@serializable(alias('class', primitive()))
	classRoom?: string;

	@serializable(alias('section', primitive()))
	section?: string;
}

export class FilterLeaderboard {
    
    @serializable(alias('InstId', primitive()))
	instituteId?: number;

    @serializable(alias('BranchId', primitive()))
	branchId?: number;

    @serializable(alias('BoardId', primitive()))
	boardId?: number;

    @serializable(alias('SectionId', primitive()))
	sectionId?: number;
    
    @serializable(alias('SubjectId', primitive()))
	sectionSubjectId?: number;
    
    @serializable(alias('GradeId', primitive()))
	branchClassRoomId?: number;

    @serializable(alias('exam_id', primitive()))
	examId?: number;

    @serializable(alias('type', primitive()))
	type?: string;

	@serializable(alias('search', primitive()))
	search?: string;

	@serializable(alias('CurrentPage', primitive()))
	page?: number;

	@serializable(alias('Pagesize', primitive()))
	pageSize?: number;

}
export class SectionSubjects {
    @serializable(alias('id', primitive()))
	id?: number;

    @serializable(alias('name', primitive()))
	name?: string;
}